import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-57fd153c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "common-title"
};
const _hoisted_2 = {
  key: 0,
  class: "icon-left",
  src: "https://image.zhihuishu.com/zhs/b2cm/base1/202505/a8fde048d5cf48a187538f5de84a8dfc.png"
};
const _hoisted_3 = {
  key: 1,
  class: "icon-right",
  src: "https://image.zhihuishu.com/zhs/b2cm/base1/202505/37fb39fbf8fd40289e11920de147eecd.png"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: _normalizeClass(["title", {
      'title-green': $props.flag
    }])
  }, [_createElementVNode("span", {
    class: _normalizeClass(["text", {
      whiteText: $props.flag
    }])
  }, [$props.showIcon ? (_openBlock(), _createElementBlock("img", _hoisted_2)) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "default", {}, undefined, true), $props.showIcon ? (_openBlock(), _createElementBlock("img", _hoisted_3)) : _createCommentVNode("", true)], 2)], 2)]);
}